<div class="take-over-confirm-content">
  <p class="take-over-confirm-message">
    This page is already being used by <strong>{{ currentUsername }}</strong
    >. Do you want to take over?
  </p>
  <div class="take-over-confirm-actions">
    <button type="button" class="take-over-cancel-btn" (click)="onCancel()">
      Cancel
    </button>
    <div class="take-over-slider-wrap">
      <evrideo-slide-to-confirm (confirmed)="onSlideConfirmed()">
      </evrideo-slide-to-confirm>
    </div>
  </div>
</div>
